// 创建新的 "IMAGE & TEXT" 块的函数
function createImageTextBlock(imageUrl, title, description, linkUrl) {
    const imageTextBlock = document.createElement('div');
    imageTextBlock.className = 'image-text-block';
    
    // 如果有链接，将图片和标题包装在 <a> 标签中
    const imageContent = linkUrl 
        ? `<a href="${linkUrl}" class="image-text-link"><img src="${imageUrl}" alt="${title}" class="image-text-image"></a>`
        : `<img src="${imageUrl}" alt="${title}" class="image-text-image">`;
    
    const titleContent = linkUrl
        ? `<a href="${linkUrl}" class="image-text-link"><h3 class="image-text-title">${title}</h3></a>`
        : `<h3 class="image-text-title">${title}</h3>`;
    
    imageTextBlock.innerHTML = `
        <div class="image-section">
            ${imageContent}
        </div>
        <div class="text-section">
            ${titleContent}
            <p class="image-text-description">${description}</p>
        </div>
    `;
    
    return imageTextBlock;
}

// 插入新的 "IMAGE & TEXT" 块的函数
function insertImageTextBlock(imageUrl, title, description, insertAfterIndex, linkUrl) {
    const productList = document.querySelector('.product-list');
    const productCards = productList.querySelectorAll('.product-card');
    
    if (!productList) {
        console.error('找不到产品列表容器');
        return;
    }
    
    // 创建新的 image & text 块
    const newBlock = createImageTextBlock(imageUrl, title, description, linkUrl);
    
    // 计算插入位置
    const insertPosition = Math.min(insertAfterIndex, productCards.length);
    
    if (insertPosition >= productCards.length) {
        // 如果位置超出范围，添加到末尾
        productList.appendChild(newBlock);
    } else {
        // 在指定位置后插入
        const referenceNode = productCards[insertPosition];
        productList.insertBefore(newBlock, referenceNode.nextSibling);
    }
    
    // 更新网格布局样式
    updateGridLayout();
}

// 更新网格布局的函数
function updateGridLayout() {
    const productList = document.querySelector('.product-list');
    if (productList) {
        // 添加网格布局类
        productList.classList.add('product-grid-with-image-text');
    }
}

// 响应式布局调整函数
function adjustLayoutForScreenSize() {
    const productList = document.querySelector('.product-list');
    if (!productList) return;
    
    const screenWidth = window.innerWidth;
    
    if (screenWidth <= 768) {
        // 手机端：单列布局
        productList.style.gridTemplateColumns = '1fr';
        productList.style.gap = '15px';
    } else if (screenWidth <= 1024) {
        // 平板端：双列布局
        productList.style.gridTemplateColumns = 'repeat(2, 1fr)';
        productList.style.gap = '20px';
    } else {
        // 桌面端：四列布局
        productList.style.gridTemplateColumns = 'repeat(4, 1fr)';
        productList.style.gap = '20px';
    }
}

// 使用示例
function addNewImageTextBlocks() {
    // 在第一个位置后插入第一个 "IMAGE & TEXT" 块
    insertImageTextBlock(
        'https://cdn.shopify.com/s/files/1/0645/1150/8615/files/Luxotic-bamboo-cotton-sheet-set-46_891a6441-3529-486d-b3a0-4bf66e9ed536.jpg?v=1757948846',
        'Bamboo Cotton Sheet Set',
        'Indulge in the silky-smooth luxury of our bamboo cotton blend sheets, crafted in a classic sateen weave for a hotel-quality feel at home.',
        5,  // 在第6个产品后插入
        '/products/bamboo-cotton-sheet-set-480-thread-count' 
         // 链接URL，请根据需要填写
    );
    
    // // 在第二个位置后插入第二个 "IMAGE & TEXT" 块
    // insertImageTextBlock(
    //     'https://cdn.shopify.com/s/files/1/0645/1150/8615/files/feature-collection-placeholder.png?v=1753933487',
    //     'Holiday Every Day',
    //     'Mesmerizing patterns from the series' third season: elephants with entwined trunks, cobras and the iconic lotus flower.',
    //     11,  // 在第12个产品后插入
    //     ''   // 链接URL，请根据需要填写
    // );

    //     // 在第三个位置后插入第三个 "IMAGE & TEXT" 块
    // insertImageTextBlock(
    //     'https://cdn.shopify.com/s/files/1/0645/1150/8615/files/feature-collection-placeholder.png?v=1753933487',
    //     'Holiday Every Day',
    //     'Mesmerizing patterns from the series' third season: elephants with entwined trunks, cobras and the iconic lotus flower.',
    //     21,  // 在第18个产品后插入
    //     ''   // 链接URL，请根据需要填写
    // );
}

// 监听窗口大小变化
function handleResize() {
    adjustLayoutForScreenSize();
}

// 页面加载完成后执行
document.addEventListener('DOMContentLoaded', function() {
    // 初始化网格布局
    updateGridLayout();
    
    // 调整初始布局
    adjustLayoutForScreenSize();
    
    // 添加新的 image & text 块
    addNewImageTextBlocks();
    
    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);
});

// 导出函数供外部使用
window.insertImageTextBlock = insertImageTextBlock;
window.createImageTextBlock = createImageTextBlock;
window.adjustLayoutForScreenSize = adjustLayoutForScreenSize; 